import { CustomerUserFormPage } from "@/features/customer-user/pages/CustomerUserFormPage";

const CustomerUserCreate = () => {
  return <CustomerUserFormPage mode="create" />;
};

export default CustomerUserCreate;
